import type { DataUpload, TilesetAnchor } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type SetTilesetLocationParams = {
	id: string;
	lon: number;
	lat: number;
	height?: number;
	heading?: number;
	anchor?: TilesetAnchor;
};

/**
 * Repositions a ready tileset (no re-tiling). The backend proxies the PATCH to
 * the tile server and persists the new location + refreshed tileset URL.
 */
export async function setTilesetLocation({ id, ...body }: SetTilesetLocationParams): Promise<DataUpload | null> {
	const response = await axios.patch(API_URLS.DATA_UPLOAD.TILESET_LOCATION(id), body);
	return getResponse<DataUpload>(response.data);
}
